import Modal from "@/components/Common/Modal";
import useFetchUserFromAuthToken from "@/hooks/useFetchUserFromAuthToken";
import {useIsLoggedIn, useSelectedCompany} from "@/hooks/useUserHooks";
import BrandLogo from "@/pages/profile/BrandLogo";
import RegistrationBottomView from "@/pages/registerCompany/RegistrationBottomView";
import RegistrationTopView from "@/pages/registerCompany/RegistrationTopView";
import CompanyDetailsStep from "@/pages/registerCompany/steps/CompanyDetailsStep";
import CredentialsStep from "@/pages/registerCompany/steps/CredentialsStep";
import InterestSelectionStep from "@/pages/registerCompany/steps/InterestSelectionStep";
import useRegistrationStore from "@/store/registration";
import useUserStore from "@/store/user";
import {useTranslation} from "react-i18next";
import {useEffectOnce} from "react-use";

const RegistrationModal = () => {
  const {t} = useTranslation(["verify_account", "common"]);
  const isLoggedIn = useIsLoggedIn();
  const user = useUserStore(state => state.user);
  const selectedCompany = useSelectedCompany();
  const step = useRegistrationStore(state => state.step);
  const setValue = useRegistrationStore(state => state.setValue);

  const {isLoading} = useFetchUserFromAuthToken(data => {
    setValue("isRegisteringAfterDirectPurchase", true);
    setValue("isEmailPrefilled", true);
    setValue("companyId", Number(data.sub_brands?.[0]?.company?.id));
    setValue("userId", Number(data.id));
    setValue("email", data.email!);
    setValue("package_subscription", data.package_subscription);
  });

  useEffectOnce(() => {
    if (isLoggedIn) {
      setValue("isRegisteringAfterDirectPurchase", true);
      setValue("isEmailPrefilled", true);
      setValue("companyId", Number(selectedCompany?.id));
      setValue("userId", Number(user.id));
      setValue("email", user.email!);
    }
  });

  if (isLoading) return null;

  return (
    <Modal onClose={() => undefined} customTitleRow={<></>} customBottomRow={<></>} shouldHideCloseButton>
      <div className="flex w-full max-w-[730px] flex-col items-center gap-[60px] self-center">
        <h2 className="text-neutral-black my-0 self-stretch text-center text-4xl font-bold sm:text-5xl">
          {t("finish_setting_up_your_account")}
        </h2>
        <div className="self-stretch">
          <RegistrationTopView isRefluencedLogoVisible={false} />
        </div>
        {step === "company_details" && (
          <div className="flex flex-col items-center gap-5 self-stretch">
            <span className="text-neutral-black text-xl font-semibold">{t("common:addCompanyLogo")}</span>
            <BrandLogo />
          </div>
        )}
        <div className="self-stretch">
          {step === "credentials" && <CredentialsStep />}
          {step === "company_details" && <CompanyDetailsStep />}
          {step === "interest_selection" && <InterestSelectionStep />}
        </div>
        <div className="self-stretch">
          <RegistrationBottomView isInsideModal />
        </div>
      </div>
    </Modal>
  );
};

export default RegistrationModal;
